import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "../Button/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { isFiniteNumber } from "../../helpers/utils.js";
import { NumericalBadge } from "../Badge/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index35.css';const tabs = "_tabs_k98fx_1";
const tab = "_tab_k98fx_1";
const fill = "_fill_k98fx_11";
const selected = "_selected_k98fx_58";
const badge = "_badge_k98fx_86";
const s = {
  tabs,
  tab,
  fill,
  selected,
  badge
};
const Tab = forwardRef((props, ref) => {
  const {
    selected: selected2 = false,
    badgeValue,
    badgeColor = "default",
    containerClassName,
    disabled,
    className,
    fill: fill2,
    ...restProps
  } = props;
  const rightIcon = isFiniteNumber(badgeValue) ? /* @__PURE__ */ jsx(NumericalBadge, { className: s.badge, count: badgeValue, badgeColor: disabled ? "disabled" : badgeColor }) : null;
  return /* @__PURE__ */ jsx(
    Button,
    {
      ...restProps,
      theme: "custom",
      className: clsx(className, s.tab, {
        [s.selected]: selected2,
        [s.fill]: fill2
      }),
      containerClassName: clsx(s.tabContentContainer, containerClassName),
      ref,
      disabled,
      rightIcon
    }
  );
});
const Tabs = withThemeAndSize(
  forwardRef(({ children, className, fill: fill2 = false, ...restProps }, ref) => /* @__PURE__ */ jsx("div", { ...restProps, className: clsx(s.tabs, { [s.fill]: fill2 }, className), ref, children }))
);
export {
  Tab,
  Tabs
};
